<template>
  <div class="main-container has-table">
    <div class="filter-container" ref="filterContainer">
      <el-select-v2 v-if="shopUserList.length > 1" class="filter-item" v-model="filters.brand_id" filterable clearable
        :options="shopUserList" :props="{
          value: 'brand_id',
          label: 'brand_name',
        }" placeholder="线下结算商户" style="width: 150px" />
      <el-input class="filter-item" v-model.trim="filters.order_no" placeholder="输入订单号" clearable></el-input>
      <el-input class="filter-item" v-model.trim="filters.phone" placeholder="手机号" clearable></el-input>
      <el-select class="filter-item" v-model="filters.status" placeholder="订单状态" clearable>
        <el-option :value="0" label="待分配"></el-option>
        <el-option :value="1" label="已分配"></el-option>
        <el-option :value="2" label="已完成"></el-option>
        <el-option :value="3" label="已退款"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="filters.receipt_status" placeholder="结算状态" clearable>
        <el-option :value="0" label="未结算"></el-option>
        <el-option :value="1" label="已结算"></el-option>
      </el-select>
      <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="支付开始时间" type="datetime" value-format="YYYY-MM-DD HH:mm:ss">
      </el-date-picker>
      <span class="filter-item filter-divider">-</span>
      <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="支付结束时间"   type="datetime" value-format="YYYY-MM-DD HH:mm:ss">
      </el-date-picker>
      <el-date-picker class="filter-item" v-model="filters.receipt_start" placeholder="上传凭证开始时间"
        value-format="YYYY-MM-DD"></el-date-picker>
      <span class="filter-item filter-divider">-</span>
      <el-date-picker class="filter-item" v-model="filters.receipt_end" placeholder="上传凭证结束时间"
        value-format="YYYY-MM-DD"></el-date-picker>
      <el-date-picker class="filter-item" v-model="filters.receipt_pay_date" placeholder="选择付款时间"
        value-format="YYYY-MM-DD"></el-date-picker>
      <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
      <el-button class="filter-btn" type="primary" @click="output()">导出</el-button>
      <el-button class="filter-btn" type="primary" @click="selectmonth()" :disabled="!filters.start_date || !filters.end_date || !filters.brand_id || filters.receipt_status !== 0">按条件批量处理</el-button>
    </div>
    <el-table ref="multipleTable" :data="tableData" border :span-method="objectSpanMethod" v-loading="isLoading"
      @selection-change="onSelectionChange" @select-all="onSelectAll" :header-cell-class-name="tableSelection">
      <el-table-column type="selection" :selectable="checkSelectable"></el-table-column>
      <el-table-column prop="order_no" label="订单号"></el-table-column>
      <el-table-column label="商品">
        <template #default="scope">
          <el-image style="width: 50px; height: 40px" :src="scope.row.image_path" :zoom-rate="1.2"
            :preview-src-list="srcList" fit="cover" @click="srcList = [scope.row.image_path]" :z-index="1000"
            :preview-teleported="true" />
        </template>
      </el-table-column>
      <el-table-column label="商品信息" width="200px">
        <template #default="scope">
          <div class="ellipsis" :title="scope.row.brand_name">
            品牌：{{ scope.row.brand_name }}
          </div>
          <a :title="scope.row.product_name" :href="`${Keys.dsUrl}/h5/product/show?id=${scope.row.product_id}`"
            target="_blank">商品：{{ scope.row.product_name }}</a>
          <div :title="scope.row.spec_name">
            规格：{{ scope.row.spec_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价/数量">
        <template #default="scope">
          {{ `${scope.row.price}` }} /
          <b class="color-danger">{{ `${scope.row.quantity}` }}</b>
        </template>
      </el-table-column>
      <el-table-column prop="ship_amount" label="运费" width="60px"></el-table-column>
      <el-table-column prop="total_amount" label="订单金额"></el-table-column>
      <el-table-column label="发货信息" width="200px">
        <template #default="scope">
          收货人：{{ scope.row.name }}<br />手机号：{{ scope.row.phone }}<br />
          <span v-if="scope.row.status == 3">退款时间:{{ scope.row.refund_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="配送时间">
        <template #default="scope">
          {{ scope.row.ship_time === "0000-00-00" ? "" : `${scope.row.ship_time} ` }}
        </template>
      </el-table-column>
      <el-table-column prop="paid_at" label="支付时间" width="95px"></el-table-column>
      <el-table-column prop="statue" label="订单状态" width="100px">
        <template #default="scope">
          <div v-if="scope.row.status == 0">待分配</div>
          <div v-else-if="scope.row.status == 1">已分配</div>
          <div v-else-if="scope.row.status == 2">已完成</div>
          <div v-else-if="scope.row.status == 3">已取消</div>
        </template>
      </el-table-column>
      <el-table-column prop="act_clearing_newprice" label="结算金额" width="95px"></el-table-column>
      <el-table-column label="结算状态" width="100px">
        <template #default="scope">
          <div v-if="scope.row.receipt_status == 0">未结算</div>
          <div v-else-if="scope.row.receipt_status == 1">已结算</div>
        </template>
      </el-table-column>
      <el-table-column prop="receipt_pay_date" label="付款时间" width="95px"></el-table-column>
      <el-table-column prop="receipt_date" label="上传凭证时间" width="95px"></el-table-column>
      <el-table-column label="备注" width="160px">
        <template #default="scope">
          <p>{{ scope.row.receipt_node }}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作人" width="95px" prop="user_name"></el-table-column>
      <el-table-column label="操作" fixed="right" :width="160">
        <template #default="scope">
          <div class="action-list">
            <el-button type="primary" size="small" @click="settlement(scope.row, 1)">{{ scope.row.receipt_status == 1 ? "查看结算凭证" : "上传结算凭证" }}</el-button>
            <el-button type="primary" size="small" @click="copyRow(scope.row)"
              style="margin-bottom: 10px; margin-top: 10px">一键复制</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" size="small" class="bottom-btn" @click="settlement(MultipleList, 2)"
      :disabled="MultipleBtn">批量处理</el-button>
    <Pagination :currentPage="filters.page" :total="count" @pageChange="handleCurrentChange"
      @sizeChange="handleSizeChange" />
    <!-- 结算凭证弹窗 -->
    <el-dialog :title="dialogTitle" ref="settlementForm" width="40%" v-model="dialogVisible"
      :before-close="onDialogClose" :close-on-click-modal="false" :close-on-press-escape="false"
      @opened="handleDialogOpened">
      <el-form :model="settlementOptions" :inline="true" :rules="addSettlementFrom" label-width="120px"
        ref="receiptForm">
        <el-form-item label="" v-if=" type == 1 && (dialogTitle !== '查看结算凭证' || (dialogTitle === '查看结算凭证' && settlementOptions.order_nums == 1))" label-width="120px" class="full-width-item first-item">
          <div>品牌名称：{{ settlementOptions.brand_name }}</div>
        </el-form-item>
        <el-form-item label="" v-if="
          type == 1 &&
          (dialogTitle !== '查看结算凭证' ||
            (dialogTitle === '查看结算凭证' &&
              settlementOptions.order_nums == 1))
        " class="full-width-item first-item">
          <div>订单号：{{ settlementOptions.order_no }}</div>
        </el-form-item>
        <el-form-item label="" v-if="
          type == 1 &&
          (dialogTitle !== '查看结算凭证' ||
            (dialogTitle === '查看结算凭证' &&
              settlementOptions.order_nums == 1))
        " class="full-width-item firat-item-font">
          <div>结算金额：{{ settlementOptions.act_clearing_newprice }}</div>
        </el-form-item>
        <el-form-item label="" v-if="type == 2 || settlementOptions.order_nums > 1" class="full-width-item first-item">
          <div>共计{{ order_count || settlementOptions.order_nums }}个订单</div>
        </el-form-item>
        <el-form-item label="" v-if="type == 2 || settlementOptions.order_nums > 1" class="full-width-item first-item">
          <div>品牌名称：{{ settlementOptions.brand_name }}</div>
        </el-form-item>
        <el-form-item label="" v-if="type == 2 || settlementOptions.order_nums > 1"
          class="full-width-item firat-item-font">
          <div>
            结算金额总计：{{ totalSettlementAmount || settlementOptions.clearing_total_amount }}
          </div>
        </el-form-item>
        <el-form-item label="付款截图：" prop="poster">
          <draggable v-model="settlementOptions.poster" class="flex-row">
            <div class="flex-row-item preview-item" v-for="(item, index) in settlementOptions.poster" :key="item.id">
              <div class="content-img-container">
                <el-image class="main-img" :src="item.url" :preview-src-list="mainPreviewList" fit="scale-down"
                  hide-on-click-modal append-to-body :z-index="3000" :initial-index="index"></el-image>
              </div>
              <el-icon @click="onImgRemove(index, 1)" v-if="
                dialogTitle !== '查看结算凭证' ||
                (dialogTitle == '查看结算凭证' && editStatus) ">
                <Delete />
              </el-icon>
            </div>
            <el-upload v-if="
              dialogTitle !== '查看结算凭证' ||
              (dialogTitle == '查看结算凭证' && editStatus)
            " ref="imageUpload" class="el-upload-list__item empty-item" accept=".jpg,.jpeg,.png,.gif"
              action="uploadUrl" :http-request="poster_img" :file-list="settlementOptions.poster"
              :show-file-list="false" list-type="picture-card" multiple style="width: auto" :drag="true">
              <el-icon>
                <Plus />
              </el-icon>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="付款金额：" prop="receipt_amount">
          <el-input v-model="settlementOptions.receipt_amount"
            :disabled="dialogTitle == '查看结算凭证' && !editStatus"><template #suffix>元</template></el-input>
        </el-form-item>
        <el-form-item label="" v-if="settlementOptions.receipt_pay_nos" prop="receipt_pay_nos" class="full-width-item">
          <div v-for="(item, index) in settlementOptions.receipt_pay_nos.split( ',')" :key="index" style="width: 100%">
            {{ item }}
          </div>
        </el-form-item>
        <el-form-item label="备注：" prop="receipt_node">
          <el-input type="textarea" v-model.trim="settlementOptions.receipt_node" :autosize="{ minRows: 2, maxRows: 4 }"
            show-word-limit :disabled="dialogTitle == '查看结算凭证' && !editStatus"></el-input>
        </el-form-item>
        <el-form-item label="付款时间：" prop="receipt_pay_date">
          <el-date-picker class="filter-item" v-model="settlementOptions.receipt_pay_date" placeholder="选择付款时间"
            value-format="YYYY-MM-DD" :disabled="dialogTitle == '查看结算凭证' && !editStatus"
            :disabled-date="disableFutureDates">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传发票：" prop="invoice_img">
          <draggable v-model="settlementOptions.invoice_img_list" class="flex-row">
            <div class="flex-row-item preview-item" v-for="(item, index) in settlementOptions.invoice_img_list"
              :key="item.id">
              <template v-if="item.type === 'pdf'">
                <div style="max-width: 148px; max-height: 148px">
                  <el-link v-if="item.file_name" :href="item.url" target="_blank">{{ item.file_name }}</el-link>
                  <el-icon v-if="
                    dialogTitle !== '查看结算凭证' ||
                    (dialogTitle == '查看结算凭证' && editStatus)
                  " class="icon" @click="onRemove(index, 2)">
                    <Delete />
                  </el-icon>
                </div>
              </template>
              <div class="content-img-container" v-else>
                <el-image class="main-img" :src="item.url" :preview-src-list="invoiceImgList" fit="scale-down"
                  hide-on-click-modal append-to-body :z-index="3000" :initial-index="index"></el-image>
              </div>
              <el-icon @click="onImgRemove(index, 2)" v-if="
                dialogTitle !== '查看结算凭证' ||
                (dialogTitle == '查看结算凭证' && editStatus)
              ">
                <Delete />
              </el-icon>
            </div>
            <el-upload v-if="
              dialogTitle !== '查看结算凭证' ||
              (dialogTitle == '查看结算凭证' && editStatus)
            " ref="imageUpload" class="el-upload-list__item empty-item" accept=".jpg,.jpeg,.png,.gif"
              action="uploadUrl" :http-request="invoice_img" :file-list="settlementOptions.invoice_img_list"
              :show-file-list="false" list-type="picture-card" multiple style="width: auto" :drag="true">
              <el-icon>
                <Plus />
              </el-icon>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="" v-if="dialogTitle == '查看结算凭证' && !editStatus" style="margin-left: 40px">
          <el-button type="success" @click="edit()" v-if="dialogTitle == '查看结算凭证' && !editStatus">修 改</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <span v-if=" dialogTitle !== '查看结算凭证' ||  (dialogTitle == '查看结算凭证' && editStatus) ">
          <el-button type="primary" @click="submit(0)" v-if=" dialogTitle !== '查看结算凭证'">保 存</el-button>
          <el-button type="primary" @click="submit(1)" v-if="dialogTitle == '查看结算凭证' && editStatus">保 存</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import {
  defineComponent,
  getCurrentInstance,
  toRefs,
  reactive,
  nextTick,
  watch,
} from "vue";
import { useStore } from "@/store/index";
import { joinParams } from "@/utils/index";
import Keys from "@/constant/key";
import { VueDraggableNext } from "vue-draggable-next";
import Pagination from "@/components/Pagination";
import { ElMessage } from "element-plus";
import { fileUpload } from "@/utils/upload";
import { Plus, Delete } from "@element-plus/icons-vue";
import { ShipTypes } from "@/enums/order";
import { getLastMonthToday, getCurrentDate } from '@/utils/index'

export default defineComponent({
  name: "OneSettlementList",
  components: { Pagination, Plus, Delete, draggable: VueDraggableNext },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const today = new Date();
    const currentTimeString = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}:${today.getSeconds().toString().padStart(2, '0')}`;
    const state = reactive({
      srcList: [],
      o: route.query.o || null,
      filters: {
        status: "",
        tmp_secondary_id: [],
        receipt_pay_start: "",
        receipt_pay_end: "",
        order_no: "",
        phone: "",
        receipt_status: 0,
        start_date: route.query.start_date || `${getLastMonthToday()} ${currentTimeString}`,
        end_date: route.query.end_date || `${getCurrentDate()} ${currentTimeString}`,
        receipt_date: "",
        timeClick: "",
        brand_id: "",
        limit: 10,
        page: 1,
        is_export: 0,
      },
      tableData: [],
      isLoading: false, // 表格数据加载状态
      shopUserList: [],
      spanArr: null,
      pos: 0,
      count: 0,
      dialogTitle: "",
      isCopied: false,
      dialogVisible: false,
      settlementOptions: {
        receipt_amount: "",
        receipt_pay_date:"",
        receipt_node: "",
        poster: [],
        brand_name: "",
        order_no: "",
        act_clearing_newprice: "",
        pay_vouther_no: "",
        invoice_img_list: [],
        receipt_pay_nos: "",
        receipt_img_data:[],
      },
      MultipleList: [],
      type: 1,
      totalSettlementAmount: 0,
      MultipleBtn: false,
      order_count: 0,
      mainPreviewList: [],
      invoicePreviewList: [],
      currentorder: {},
      brandName: "",
      editStatus: false,
      flag: false,
      receipt_img_data:[],
      stash_poster_data:[],
      handleSizeChange(val) {
        state.filters.limit = val;
        state.MultipleBtn = false;
        state.getList();
      },
      handleCurrentChange(val) {
        state.filters.page = val;
        state.MultipleBtn = false;
        state.getList();
      },
      getList() {
        // state.isLoading = true
        proxy.$http
          .get(`/admin/brands/get_ydyj_order_list?${joinParams(state.filters)}`)
          .then((res) => {
            const { code, data, msg } = res;
            if (code != 200) {
              state.tableData = [];
              state.count = 0;
              state.isLoading = false;
              return proxy.$message({ type: "error", message: res.msg });
            }
            state.tableData = data.data;
            state.spanArr = data.data;
            state.count = data.total;
            state.getSpanArr(state.spanArr);
            state.srcList = [
              "https://img.dangaoss.com/public/p/72/0/1176489_l.jpg",
            ];
            state.isLoading = false;
          });
      },
      search(type) {
        if (type) {
          state.filters.start_date = "";
          state.filters.end_date = "";
        }
        state.filters.page = 1;
        state.getList();
      },
      output() {
        window.open(
          `${Keys.baseUrl}/admin/brands/get_ydyj_order_list?${joinParams({
            ...state.filters,
            is_export: 1,
            user_id: store.state.user.userInfo.id,
          })}`
        );
      },
      selectmonth(){
        state.filters.page = 1;
        state.getList();
        const params = {
          brand_id: state.filters.brand_id,
          start_date: state.filters.start_date,
          end_date: state.filters.end_date,
          user_id: store.state.user.userInfo.id,
          user_name: store.state.user.userInfo.username,
        };
        proxy.$http.get('/admin/brands/get_ydyj_amount', params).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                if(data.order_nums > 0){
                  state.settlementOptions.brand_name = data.brand_name;
                  state.currentorder.order_id = data.order_str;
                  state.currentorder.order_str = data.order_str;
                  state.order_count = data.order_nums;
                  state.totalSettlementAmount = data.order_clearing_price;
                  state.type = 2;
                  state.dialogTitle = "批量处理";
                  state.dialogVisible = true;
                }else{
                  proxy.$message({ type: "error", message: "没有可结算的订单" });
                }
        })
      },
      getShopList: () => {
        proxy.$http
          .get(
            `/admin/brands/get_ydyj_brand_list?user_id=${store.state.user.userInfo.id}$user_name=${store.state.user.userInfo.username}`
          )
          .then((res) => {
            if (res.code == 200) {
              state.shopUserList = res.data;
            } else {
              state.shopUserList = [];
            }
          });
      },
      getSpanArr: (resData) => {
        state.spanArr = [];
        if (resData === null) {
          return;
        }
        for (let i = 0; i < resData.length; i++) {
          if (i === 0) {
            state.spanArr.push(1);
            state.pos = 0;
          } else {
            if (resData[i].order_id === resData[i - 1].order_id) {
              state.spanArr[state.pos] += 1;
              state.spanArr.push(0);
            } else {
              resData[i].hasClass = true;
              state.spanArr.push(1);
              state.pos = i;
            }
          }
        }
      },
      objectSpanMethod: ({ row, column, rowIndex, columnIndex }) => {
        let columnArray = [0, 1, 4, 5, 6, 9, 11, 12, 13, 14, 15, 16, 17];
        if (columnArray.includes(columnIndex)) {
          const _row = state.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      },
      copyRow: async (row) => {
        const chargeInfoDetails =
          row.order_charge.length > 0
            ? row.order_charge
              .map((charge) => {
                return `
                    名称：${charge.charge_name || "无"}
                    单价 / 数量：${charge.price && charge.quantity
                    ? charge.price + "/" + charge.quantity
                    : "无"
                  }
                    金额：${charge.total_amount || "无"}
                    `;
              })
              .join("\n")
            : "暂无收费信息";
        const textToCopy = ` 
                收货人姓名：${row.name || "无"}
                收货人电话：${row.phone || "无"}
                下单人电话：${row.buyer_phone || "无"}
                配送方式：${row.ship_type || "无"}
                配送时间：${ShipTypes[row.ship_type] || "无"}
                收货人地址：${row.city}${row.area}${row.addr}
                用户备注：${row.buyer_msg || "无"}
                订单号：${row.order_no || "无"}
                额外配件费：${row.delivery_fee || "无"}
                附件结算价：
                商品信息：
                        商品名称：${row.product_name || "无"}
                        规格：${row.spec_name || "无"}
                        口味：${row.tastes || "无"}
                        单价：${row.price || "无"}
                        数量：${row.quantity || "无"}   
                        商品金额：${row.price && row.quantity
            ? (
              parseFloat(row.price) * parseFloat(row.quantity)
            ).toFixed(2)
            : "无"
          }
                        结算单价：${row.act_clearing_price || "无"}
                        罚款金额：${row.fine_money || "无"}
                        罚款时间：${row.fine_time || "无"}
                        罚款原因：${row.fine_reason || "无"}
                收费附件：${chargeInfoDetails}`;

        try {
          await navigator.clipboard.writeText(textToCopy);
          ElMessage.success("复制成功");
          state.isCopied = true;
          setTimeout(() => {
            state.isCopied = false;
          }, 3000);
        } catch (err) {
          ElMessage.error("复制失败");
        }
      },
      settlement: (row, type) => {
        state.type = type;
        if (type == 1) {
          state.currentorder = row;
          state.order_count = 0;
          state.settlementOptions.brand_name = row.brand_name;
          state.settlementOptions.order_no = row.order_no;
          state.settlementOptions.act_clearing_newprice = row.act_clearing_newprice;
          state.dialogTitle = "上传结算凭证";
          state.stash_poster_data = []
          if (row.receipt_status == 1) {
            state.dialogTitle = "查看结算凭证";
            state.stash_poster_data = row.receipt_img_data
            state.settlementOptions = {
              ...state.settlementOptions,
              ...row,
              poster: row.receipt_img_url
                ? row.receipt_img_url.split(",").map((url) => ({
                  url: url,
                  uid: Date.now() + Math.floor(Math.random() * 1000),
                }))
                : [],
              invoice_img_list: row.invoice_img
                ? row.invoice_img.split(",").map((url) => ({
                  url: url,
                  uid: Date.now() + Math.floor(Math.random() * 1000),
                  type: url.split(".").pop(),
                  file_name: url.split("/").pop(),
                }))
                : [],
            };
            state.mainPreviewList = state.settlementOptions.poster.map(
              (item) => item.url
            );
            state.invoicePreviewList =
              state.settlementOptions.invoice_img_list.map((item) => item.url);
          }
        } else {
          state.stash_poster_data = []
          state.settlementOptions.brand_name = row.length
            ? row[0].brand_name
            : "";
          state.dialogTitle = "批量处理";
          if (row.length == 0) return ElMessage.error("请选择同商家未结算订单");
          state.currentorder.order_id =
            row.map((item) => item.order_id).join(",") || "";
        }
        state.dialogVisible = true;
        nextTick(() => {
          if (state.dialogTitle === "查看结算凭证" && proxy.$refs["receiptForm"]) {
            proxy.$refs["receiptForm"].clearValidate();
          }
        });
      },
      poster_img(param) {
        state.uploadPosterRequest(param, 1);
      },
      invoice_img(param) {
        state.uploadPosterRequest(param, 2);
      },
      uploadPosterRequest: async (param, type) => {
        const { code, data, msg } = await fileUpload(param.file, {
          folderName: "settlement",
        });
        if (code != 200) {
          return proxy.$message({ type: "error", message: msg });
        }
        if (type == 1) {
          // 请求凭证识别
          const voutherData = await proxy.$http.post("/admin/invoice/get_vouther_datas",{ url: data.url });
          if (voutherData.code != 200) {
            return proxy.$message({ type: "error", message: voutherData.msg });
          }
          state.settlementOptions.poster.push({ id: data.uid, url: data.url });
          const { pay_vouther_no, pay_amount, pay_time } = voutherData.data;
          // 上传
          state.stash_poster_data.push({
            id: data.uid,
            url: data.url,
            pay_vouther_no: pay_vouther_no,
            pay_amount: pay_amount,
            pay_time: pay_time,
          });
          state.settlementOptions.receipt_pay_nos =
          state.stash_poster_data.length > 0 ? state.stash_poster_data.map((item) => item.pay_vouther_no).join(",") : "";
          state.settlementOptions.receipt_amount = pay_amount;
          state.settlementOptions.receipt_pay_date = pay_time;
          nextTick(() => {
            if (proxy.$refs["receiptForm"]) {
              proxy.$refs["receiptForm"].validateField("receipt_pay_date");
            }
          });
        } else {
          // 请求发票识别
          const invoiceData = await proxy.$http.post(
            "/invoice/getInvoiceData",
            { invoice_img: data.url }
          );
          if (invoiceData.code != 200) {
            return proxy.$message({ type: "error", message: invoiceData.msg });
          }
          state.settlementOptions.invoice_img_list.push({
            id: data.uid,
            url: data.url,
            file_name: data.file_name,
            type: data.url.split(".").pop(),
          });
        }
      },
      onSelectionChange: (val) => {
        state.MultipleBtn = false;
        state.MultipleList = val;
        const brandNames = val.map((item) => item.brand_name);
        const uniqueBrandNames = new Set(brandNames);
        if (val.length > 0 && uniqueBrandNames.size > 1) {
          state.MultipleBtn = true;
          nextTick(() => {
            proxy.$refs.multipleTable.clearSelection();
          });
          return ElMessage.error("请选择同商家未结算订单");
        }
        if (val.length > 0) {
          state.order_count = val.length;
          state.totalSettlementAmount = val.reduce((acc, cur) => acc + Number(cur.act_clearing_newprice), 0).toFixed(2);
          state.currentorder.order_id = val
            .map((item) => item.order_no)
            .join(",");
        }
        if (val.length == 1) {
          state.brandName = val[0].brand_name;
        }
      },
      onSelectAll: (val) => {
        if (val.length == 0) {
          state.flag = !state.flag;
          if (state.flag) {
            state.MultipleBtn = true;
            return ElMessage.error("本页无未结算订单");
          } else {
            state.MultipleBtn = false;
          }
        }
      },
      checkSelectable(row, index) {
        if (row.receipt_status === 1) {
          return false;
        }

        if (state.MultipleList.length === 0) {
          return true;
        }

        const selectedBrand = state.MultipleList[0].brand_name;
        return row.brand_name === selectedBrand;
      },
      submit(type) {
        const { receipt_amount, act_clearing_newprice, receipt_node, poster } =
          state.settlementOptions;
        if (poster.length == 0) {
          return proxy.$message({
            type: "error",
            message: "请上传付款截图",
          });
        }
        if (state.dialogTitle) {
          if (
            state.order_count > 0 &&
            Number(receipt_amount) !== Number(state.totalSettlementAmount)
          ) {
            if (!receipt_node) {
              return proxy.$message({
                type: "error",
                message: "付款金额与结算金额不一致，请修改",
              });
            }
          }
          if (Number(receipt_amount) !== Number(act_clearing_newprice)) {
            if (!receipt_node) {
              return proxy.$message({
                type: "error",
                message: "付款金额与结算金额不一致，请输入备注信息",
              });
            }
          }
        }
        const payVoutherNos = state.stash_poster_data.map(
          (item) => item.pay_vouther_no
        );
        const hasDuplicates = new Set(payVoutherNos).size !== payVoutherNos.length;
        if (hasDuplicates)
          return proxy.$message({
            type: "error",
            message: "存在重复付款凭证，请重新上传",
          });
        proxy.$refs["receiptForm"].validate((valid) => {
          if (valid) {
            const invoice_img =
              invoicePreviewList.value.length > 0
                ? invoicePreviewList.value.map((item) => item).join(",")
                : "";
            const poster_img =
              mainPreviewList.value.length > 0
                ? mainPreviewList.value.map((item) => item).join(",")
                : "";
                const filters = {
                  ...state.settlementOptions,
                  order_id:
                    state.dialogTitle !== "查看结算凭证"
                      ? state.currentorder.order_id
                      : state.settlementOptions.order_str,
                  brand_name: state.settlementOptions.brand_name,
                  order_nums:
                    state.dialogTitle !== "查看结算凭证"
                      ? state.order_count > 0
                        ? state.order_count
                        : 1
                      : state.settlementOptions.order_nums,
                  clearing_total_amount:
                    state.dialogTitle !== "查看结算凭证"
                      ? state.totalSettlementAmount
                      : state.settlementOptions.clearing_total_amount,
                  invoice_img: invoice_img,
                  receipt_img_url: poster_img,
                  clearing_amount:
                    state.settlementOptions.act_clearing_newprice,
                  type:type,
                  receipt_img_data: state.stash_poster_data,
                }
            proxy.$http.post('/admin/brands/do_order_receipt',filters)
              .then((res) => {
                const { code, data, error_msg, msg } = res;
                if (code != 200) {
                  return proxy.$message({
                    type: "error",
                    message: error_msg || msg,
                  });
                }else{
                  proxy.$message({
                    type: "success",
                    message: "结算成功",
                  });
                }
                state.dialogVisible = false;
                state.editStatus = false;
                state.stash_poster_data = [];
                state.settlementOptions = {
                  receipt_amount: "",
                  receipt_node: "",
                  receipt_pay_date: "",
                  poster: [],
                  invoice_img_list: [],
                  brand_name: "",
                  order_no: "",
                  act_clearing_newprice: "",
                  pay_vouther_no: "",
                  invoice_img_list: [],
                  receipt_pay_nos: "",
                  receipt_img_data:[],
                };
                state.getList();
              });
          }
        });
      },
      edit() {
        state.editStatus = true;
      },
      onImgRemove: (index, type) => {
        proxy
          .$confirm("确定要删除该图片？", "提示", { type: "warning" })
          .then(() => {
            if (type == 1) {
              let targetUrl = state.settlementOptions.poster[index].url;
              const { mainPreviewList } = state;
              const { poster } = state.settlementOptions;
              mainPreviewList.splice(index, 1);
              poster.splice(index, 1);
              state.settlementOptions.poster = poster;
              state.mainPreviewList = mainPreviewList;
              // 订单号处理
              state.receipt_img_data = state.stash_poster_data.filter(item => {
                  return item.url !== targetUrl;
              });
              state.stash_poster_data = state.receipt_img_data
              state.settlementOptions.receipt_pay_nos = state.receipt_img_data.length > 0 ? state.receipt_img_data.map((item) => item.pay_vouther_no).join(",") : "";
            } else {
              const { invoicePreviewList } = state;
              const { invoice_img_list } = state.settlementOptions;
              invoicePreviewList.splice(index, 1);
              invoice_img_list.splice(index, 1);
              state.settlementOptions.invoice_img_list = invoice_img_list;
              state.invoicePreviewList = invoicePreviewList;
            }
          })
          .catch(() => {
            console.log("取消删除");
          });
      },
      onDialogClose() {
        state.dialogVisible = false;
        state.settlementOptions = {
          receipt_amount: "",
          receipt_node: "",
          receipt_pay_date: "",
          poster: [],
          invoice_img_list: [],
          brand_name: "",
          order_no: "",
          act_clearing_newprice: "",
          pay_vouther_no: "",
          invoice_img_list: [],
          receipt_pay_nos: "",
          receipt_img_data:[],
        };
        state.editStatus = false;
        state.stash_poster_data = [];
        state.receipt_img_data = [];
      },
      handleDialogOpened() {
        // 如果是查看模式，清除验证状态
        if (state.dialogTitle === "查看结算凭证") {
          nextTick(() => {
            if (proxy.$refs["receiptForm"]) {
              proxy.$refs["receiptForm"].clearValidate();
            }
          });
        }
      },
    });
    watch(
      () => state.settlementOptions.poster,
      (newPoster) => {
        if (!newPoster || newPoster.length === 0) {
          state.settlementOptions.receipt_amount = "";
          state.settlementOptions.receipt_pay_date = "";
          state.settlementOptions.receipt_pay_nos = "";
          state.settlementOptions.receipt_node = "";
          state.stash_poster_data = [];
          state.receipt_img_data = [];
        }
      },
      {
        deep: true,
        immediate: false,
      }
    );

    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          filterHeight = proxy.$refs.filterContainer.offsetHeight + 30,
          paginationHeight = 62;
        state.tableHeight =
          window.innerHeight - headerHeight - filterHeight - paginationHeight;
      });
    };
    const disableFutureDates = (date) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date.getTime() > today.getTime();
    };
    const mainPreviewList = computed(() => {
      const { poster } = state.settlementOptions;
      let tmpArr = poster.map((item) => {
        // @ts-ignore
        if ((item.id || item.uid) && item.url) {
          // @ts-ignore
          return item.url
            ?.replace("?x-oss-process=style/s_img_160", "")
            ?.replace("_s.jpg", ".jpg");
        }
      });
      state.mainPreviewList = tmpArr;
      return tmpArr;
    });
    const invoicePreviewList = computed(() => {
      const { invoice_img_list } = state.settlementOptions;
      let tmpArr = invoice_img_list.map((item) => {
        // @ts-ignore
        if ((item.id || item.uid) && item.url) {
          // @ts-ignore
          return item.url
            ?.replace("?x-oss-process=style/s_img_160", "")
            ?.replace("_s.jpg", ".jpg");
        }
      });
      state.invoicePreviewList = tmpArr;
      return tmpArr;
    });

    const invoiceImgList = computed(() => {
      const { invoice_img_list } = state.settlementOptions;
      let tmpArr = invoice_img_list.map((item) => {
        const type = item.type || item.url.split(".").pop();
        if (["jpg", "jpeg", "png", "gif"].includes(type.toLowerCase())) {
          // @ts-ignore
          if ((item.id || item.uid) && item.url) {
            // @ts-ignore
            return item.url
              ?.replace("?x-oss-process=style/s_img_160", "")
              ?.replace("_s.jpg", ".jpg");
          }
        }
      });
      state.invoicePreviewList = tmpArr;
      return tmpArr;
    });

    const validDelayTime = computed(() => {
      const { receipt_amount, act_clearing_newprice } = state.settlementOptions;
      const money =
        state.order_count > 0
          ? Number(state.totalSettlementAmount)
          : Number(act_clearing_newprice);
      return (
        Number(receipt_amount) !== money && state.dialogTitle !== "查看结算凭证"
      );
    });
    const addSettlementFrom = reactive({
      poster: [{ required: true, message: "", trigger: "change" }],
      receipt_amount: [
        { required: true, message: "请输入付款金额", trigger: "change" },
      ],
      receipt_pay_date: [
        { required: true, message: "请输入付款时间", trigger: "change" },
      ],
      receipt_node: [
        { required: validDelayTime, message: "请输入备注", trigger: "change" },
      ],
    });
    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    state.getShopList();
    state.getList();
    return {
      ...toRefs(state),
      router,
      Keys,
      store,
      mainPreviewList,
      invoicePreviewList,
      addSettlementFrom,
      validDelayTime,
      disableFutureDates,
      invoiceImgList,
    };
  },
});
</script>
<style lang="stylus" scoped>
.follow-alert {
  margin: -10px 0 10px;

  p {
    font-size: 13px;
  }

  .el-link {
    transform: translateY(-1px);
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

:deep(.deep-border td) {
  border-top: 1px solid #999;
}

.avatar-uploader {
  width: 50%;
}

:deep(.el-table .warning-row) {
  opacity: 0.5;
  position: relative;

  &::after {
    content: '已退单';
    position: absolute;
    left: 120px;
    top: 50%;
    z-index: 2;
    font-size: 24px;
    color: red;
    font-weight: bold;
    transform: rotate(-29deg) translateY(-50%);
  }
}

:deep(.el-table .el-dialog__footer) {
  text-align: left;
}

.main-img {
  display: block;
  max-width: 148px;
  max-height: 148px;
}

.bottom-btn {
  width: 100px;
  position: relative;
  top: 25px;
}

.flex-row {
  display: flex;
  gap: 10px;
}

.full-width-item {
  width: 100%;
  display: block;
  margin-left: 120px !important;
}

.first-item {
  height: 10px;
  color: black;
  font-szie: 16px;
}

.firat-item-font {
  font-size: 16px;
  color: black;
}

:deep(.el-form .el-form-item) {
  width: 100%;
}
:deep(.el-upload .el-upload-dragger){
  padding:58px 0 !important;
}
</style>
